<app-header></app-header>
<app-loader></app-loader>
<app-notification></app-notification>
<router-outlet></router-outlet>
<app-footer></app-footer>
